import { Injectable, InjectionToken, LOCALE_ID, inject } from '@angular/core';
import { isEmptyOrUndefined, trimFirstToken } from './string-util';

const apiPrefixSegments = ['api'];

export const B2B_APP_BASE_HREF = new InjectionToken<string>('', {
  providedIn: 'root',
  factory: () =>
    document.querySelector('head base')?.attributes?.getNamedItem('href')
      ?.value ?? '',
});

@Injectable({
  providedIn: 'root',
})
export class UrlHelperService {
  readonly #languageCode: string;
  readonly #appBaseHref: string;

  constructor() {
    const locale = inject(LOCALE_ID);
    const appBaseHref = inject(B2B_APP_BASE_HREF);

    this.#languageCode = locale.substring(0, 2).toLowerCase();
    this.#appBaseHref = appBaseHref;
  }

  prepareApiPath(...segments: string[]): string {
    const baseUrl = this.getNonLocalizedBasePath();
    const prefixedSegments = [baseUrl, ...apiPrefixSegments, ...segments];
    return `/${prefixedSegments
      .map((segment) => this.trimFirstSlashIfPresent(segment))
      .filter((segment) => segment.length > 0)
      .join('/')}`;
  }

  getNonLocalizedBasePath(): string {
    return this.#appBaseHref
      .replace(/\/$/, '')
      .replace(new RegExp(`/${this.#languageCode}/?$`), '');
  }

  private trimFirstSlashIfPresent(urlSegment: string): string {
    return isEmptyOrUndefined(urlSegment)
      ? urlSegment
      : trimFirstToken(urlSegment, '/');
  }
}
